import React from "react"

interface FieldProps {
  id: string
  type?: string
  label: string
  placeholder?: string
  value: string
  onChange: (value: string) => void
  icon: React.ReactNode
  required?: boolean
  extra?: React.ReactNode
}

const Field: React.FC<FieldProps> = ({
  id,
  type = "text",
  label,
  placeholder,
  value,
  onChange,
  icon,
  required,
  extra,
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-xs font-semibold text-slate-600"
      >
        {label}
      </label>

      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-300 pointer-events-none">
          {icon}
        </span>

        <input
          id={id}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          className="w-full pl-9 pr-10 py-2.5 rounded-xl border border-slate-200 bg-slate-50/60
          text-sm text-slate-700 placeholder-slate-300
          focus:outline-none focus:border-[#0F52BA] focus:ring-2 focus:ring-blue-100 focus:bg-white
          transition-all duration-150"
        />

        {extra && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2">
            {extra}
          </span>
        )}
      </div>
    </div>
  )
}

export default Field